<template>
  <v-dialog width="auto" v-model="dialog_field_creation" @click:outside="$store.commit('close_create_field_dialog')">
    <v-card>
      <v-card-title>
        ساخت تنظیمات جدید
      </v-card-title>
      <v-card-text>
        <v-text-field
            v-model="new_field_title"
            label="نام فیلد"
            required
        ></v-text-field>
        <v-select
            v-model="new_field_type"
            label="نوع فیلد"
            :items="field_types"
            return-object
            item-text="name"
            item-value="value"
        >
        </v-select>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" flat @click="$store.commit('close_create_field_dialog')">
          لغو
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="create_new_field(value.id)">
          ثبت
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import {mapState} from "vuex";

export default {
  name: "CreateFieldDialog",
  computed: {
    ...mapState({
      dialog_field_creation: state => state.Admin.settings.create_field_dialog.show,
      loading: state => state.Admin.settings.loading
    }),
  },
  data() {
    return {
      field_types: [
        {value: 1, name: 'لیست کشویی'},
        {value: 2, name: 'تگ'},
        {value: 3, name: 'کامنت'},
      ],
      value: {
        title: "",
        fields: [
          {
            name: "",
            type: "",
            value: ""
          }
        ]
      },
      new_field_title: "",
      new_field_type: "",
    }
  },
  methods: {
    create_new_field() {
      let context = this
      this.$store.dispatch('create_field', {
        title: this.new_field_title,
        type: this.new_field_type.value,
        setting_id: this.$store.state.Admin.settings.selected_setting_id
      }).then(() => {
        this.title = ""
        this.value = ""
        this.type = ""
        context.$store.commit('close_create_field_dialog')
      })
    }
  }
}
</script>

<style scoped>

</style>
